export default String.raw`
<div class="empty-page">
    <div class="empty-page__heading">
        <svg>
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{ settings.iconStyle }}"></use>
        </svg>
    <h2>{{ title }}</h2>
    </div>
    <a href="{{ page.BaseHref }}" class="empty-page__button primary-action-button">
        <div>
            <span>{{ translations.BackToMainPage }}</span>
            <svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#home-{{ settings.iconStyle }}"></use>
            </svg>
        </div>
    </a>
</div>
`